var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 33,
  fill: "none",
  viewBox: "0 0 32 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M10.63 6.864a9.667 9.667 0 0 1 12.206 14.873l-5.658 5.658a1.663 1.663 0 0 1-2.355 0l-5.658-5.658A9.667 9.667 0 0 1 10.63 6.864m13.62 16.287-.707-.707zl-5.657 5.657a3.664 3.664 0 0 1-5.184 0L7.75 23.151a11.667 11.667 0 1 1 16.5 0m-10.371-10.37a3 3 0 1 1 4.242 4.242 3 3 0 0 1-4.242-4.243M16 9.9a5 5 0 1 0 0 10 5 5 0 0 0 0-10",
  clipRule: "evenodd"
})));
export default SvgLocation;